import {
	TTableStructure,
	ETableStructureType,
	ETableStructureAlign,
	TTableStructureButton,
} from 'ui/EasTable/types';
import { TGeneralAttachmentRow } from 'redux/reducers/generalAttachments/types';
import { EIconButtons } from '../../../ui/EasTable/EasTableRow/EasTableValue/constants';

export const tableStructure: TTableStructure<keyof TGeneralAttachmentRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'File Name',
		selector: 'fileName',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},
	{
		name: 'Type',
		selector: 'type',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		editable: true,
	},
	{
		name: 'Type ID',
		selector: 'typeId',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.CENTER,
		editable: true,
	},
	{
		name: 'Is Download Allowed',
		selector: 'isDownloadAllowed',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		editable: true,
	},
	{
		name: 'Is Delete Allowed',
		selector: 'isDeleteAllowed',
		show: false,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BOOLEAN,
		align: ETableStructureAlign.CENTER,
		editable: true,
	},
	{
		name: 'Version',
		selector: 'versions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.RIGHT,
		editable: false,
		value: (item: TGeneralAttachmentRow) => String(item.versions[0].version),
	},
	{
		name: 'Created at',
		selector: 'versions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
		value: (item: TGeneralAttachmentRow) => item.versions[0].createdAt ?? '',
	},
	{
		name: 'Sort number',
		selector: 'sortNumber',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Comment',
		selector: 'versions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
		value: (item: TGeneralAttachmentRow) => item.versions[0].comment ?? '',
	},
	{
		name: 'Attached by',
		selector: 'versions',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
		value: (item: TGeneralAttachmentRow) => (item.versions[0].attachedBy ?? null) as any,
	},

	{
		name: 'Actions',
		selector: 'id',
		show: true,
		noName: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
			{
				name: 'Delete',
				icon: EIconButtons.DELETE,
			},
		],
		buttonFilter: (item: TGeneralAttachmentRow) => {
			const buttons = [] as TTableStructureButton[];
			// buttons.push({ name: 'Update', icon: EIconButtons.EDIT });
			buttons.push({ name: 'Upload New Version', icon: EIconButtons.UPLOAD });
			if (item.isDownloadAllowed) buttons.push({ name: 'Download', icon: EIconButtons.DOWNLOAD });
			// if (item.isDeleteAllowed)
			// 	buttons.push({ name: 'Delete', icon: EIconButtons.DELETE, color: 'error.main' });
			return buttons;
		},
	},
];
